import * as React from "react";
const useImageLoaded = (ref) => {
  const [loaded, setLoaded] = React.useState(false);
  const onLoad = () => {
    setLoaded(true);
  };
  React.useEffect(() => {
    if (ref?.current?.complete && ref.current.naturalWidth !== 0) {
      onLoad();
    }
  }, [ref]);
  return [loaded, onLoad];
};
export {
  useImageLoaded
};
//# sourceMappingURL=use-image-loaded.js.map
